export default function toJSON(data) {
    return JSON.parse(JSON.stringify(data));
}
